<template>
  <list :state="1" ref="list">
    <template slot-scope="{ data }">
      <el-link v-action="'/api/ProjectManage/Enroll/Nullify'" type="warning" @click="onNullify(data.Id)">作废</el-link>
    </template>
  </list>
</template>
<script>
export default {
  components: { list: () => import("./list.vue") },
  methods: {
    //审批
    onNullify (id) {
      this.$confirm('此操作将作废报备信息, 是否继续?', '作废', {
        center: true
      }).then(() => {
        this.$apis.project.enroll.nullify({ id: id }).then(() => {
          this.$refs.list.loadData()
          this.$message({ message: "执行成功！", type: "success" })
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    }
  }
}
</script>